import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

const FONT_MAP = { sm: "14px", md: "16px", lg: "18px" };

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("arc_theme") || "light");
  const [fontSize, setFontSizeState] = useState(() => localStorage.getItem("arc_fontsize") || "md");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("arc_theme", theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.style.fontSize = FONT_MAP[fontSize] || "16px";
    localStorage.setItem("arc_fontsize", fontSize);
  }, [fontSize]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const setFontSize = (size) => setFontSizeState(FONT_MAP[size] ? size : "md");

  return <ThemeContext.Provider value={{ theme, toggle, fontSize, setFontSize }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
